/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */
import type { FC } from 'react';
import React from 'react';

import { themeSSRManager } from '@confluence/ssr-utilities/entry-points/ThemeSSRManager';
import { useIsMobileApp } from '@confluence/mobile-app-detection/entry-points/MobileAppDetection';

export const SSRThemeInit: FC<{ uri?: string }> = ({ uri }) => {
	const nonceValue = window.__SSR_NONCE_VALUE__;
	const { isMobileApp } = useIsMobileApp(uri);

	return (
		<script
			{...(nonceValue !== undefined ? { nonce: nonceValue } : {})}
			dangerouslySetInnerHTML={{
				__html: `if(window["__SSR_RENDERED__"]){${themeSSRManager.getThemeHtmlAttrsScript({
					forceAuto: isMobileApp,
				})}}`,
			}}
		/>
	);
};
